module.exports = __webpack_public_path__ + "img/cart-empty.7c73b697.png";